import VariationOrderCategory from '@/models/VariationOrderCategory';
import VariationOrderCategoryService from '@/services/VariationOrderCategoryService';
import { defineStore } from 'pinia';
import { useRepo } from 'pinia-orm';

export const useVariationOrderCategoriesStore = defineStore('variation_order_categories', {
  state: () => ({}),

  getters: {
    models: () => useRepo(VariationOrderCategory),
  },

  actions: {
    async indexProject(projectId: Id) {
      const [data, error] = await VariationOrderCategoryService.indexProject(projectId);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async indexPackage(projectId: Id, packageId: Id) {
      const [data, error] = await VariationOrderCategoryService.indexPackage(projectId, packageId);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async storeProject(projectId: Id, request: ApiRequests['api.v1.variation-order-categories.store']) {
      const [data, error] = await VariationOrderCategoryService.storeProject(projectId, request);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async storePackage(
      projectId: Id,
      packageId: Id,
      request: ApiRequests['api.v1.packages.variation-order-categories.store'],
    ) {
      const [data, error] = await VariationOrderCategoryService.storePackage(projectId, packageId, request);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async update(id: Id, request: ApiRequests['api.v1.variation-order-categories.update']) {
      const [data, error] = await VariationOrderCategoryService.update(id, request);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async destroy(id: Id) {
      const [data, error] = await VariationOrderCategoryService.destroy(id);

      if(error) {
        throw error;
      }

      this.models.destroy(data.variation_order_category.id);

      this.models.save(data.sort_order);

      return data;
    },

    async sort(id: Id, request: ApiRequests['api.v1.variation-order-categories.sort']) {
      const [data, error] = await VariationOrderCategoryService.sort(id, request);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },
  },
});
